import { logError } from '../lib/utils.js'
import { supabase } from './supabase/supabaseClient.js'

// Obtener todos los productos
export const getProductos = async (client = supabase) => {
  try {
    const { data, error } = await client
      .from('producto')
      .select(`
        *,
        compania:companias(nombre_corto)
      `)
      .order('created_at', { ascending: false });

    if (error) {
      logError('Error al obtener productos:', error, { ignoreAbort: true });
      throw error;
    }

    return data || [];
  } catch (error) {
    logError('Error al obtener productos:', error, { ignoreAbort: true });
    throw error;
  }
};

// Obtener producto por ID
export const getProductoById = async (id) => {
  try {
    const { data, error } = await supabase
      .from('producto')
      .select(`
        *,
        compania:companias(nombre_corto)
      `)
      .eq('id', id)
      .single();

    if (error) {
      console.error('Error al obtener producto:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error al obtener producto:', error);
    throw error;
  }
};

// Crear nuevo producto
export const createProducto = async (productoData) => {
  try {
    const { data, error } = await supabase
      .from('producto')
      .insert([
        {
          nombre: productoData.nombre,
          descripcion: productoData.descripcion,
          descripcion_json: productoData.descripcion_json || null,
          compania_id: productoData.compania_id,
          yoolbrand: productoData.yoolbrand || null,
          yoolbrand_slug: productoData.yoolbrand_slug || null,
          ramo: productoData.ramo || null,
          yooladmin_subscription_plan_id: productoData.yooladmin_subscription_plan_id || null,
          imagen_url: productoData.imagen_url || null,
          imagen_hero_url: productoData.imagen_hero_url || null,
          "product-description": productoData["product-description"] || null,
          product_description_schemma: productoData.product_description_schemma || null,
          activo: productoData.activo !== undefined ? productoData.activo : true,
          archivado: productoData.archivado !== undefined ? productoData.archivado : false
        }
      ])
      .select()
      .single();

    if (error) {
      console.error('Error al crear producto:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error al crear producto:', error);
    throw error;
  }
};

// Actualizar producto
export const updateProducto = async (id, productoData, client = supabase) => {
  try {
    const { data, error } = await client
      .from('producto')
      .update({
        nombre: productoData.nombre,
        descripcion: productoData.descripcion,
        descripcion_json: productoData.descripcion_json,
        compania_id: productoData.compania_id,
        yoolbrand: productoData.yoolbrand || null,
        yoolbrand_slug: productoData.yoolbrand_slug || null,
        ramo: productoData.ramo || null,
        yooladmin_subscription_plan_id: productoData.yooladmin_subscription_plan_id || null,
        imagen_url: productoData.imagen_url || null,
        imagen_hero_url: productoData.imagen_hero_url || null,
        "product-description": productoData["product-description"] || null,
        product_description_schemma: productoData.product_description_schemma || null,
        activo: productoData.activo,
        archivado: productoData.archivado,
        updated_at: new Date().toISOString()
      })
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error('Error al actualizar producto:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error al actualizar producto:', error);
    throw error;
  }
};

// Eliminar producto
export const deleteProducto = async (id, client = supabase) => {
  try {
    const { error } = await client
      .from('producto')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Error al eliminar producto:', error);
      throw error;
    }

    return true;
  } catch (error) {
    console.error('Error al eliminar producto:', error);
    throw error;
  }
};

// Obtener companías para el selector
export const getCompanias = async (supabaseClient) => {
  try {
    const client = supabaseClient || supabase;
    const { data, error } = await client
      .from('companias')
      .select('id, nombre_corto')
      .order('nombre_corto', { ascending: true });

    if (error) {
      console.error('Error al obtener compañías:', error);
      throw error;
    }

    // Fallback: si RLS retorna [], derivar compañías desde productos visibles
    if (Array.isArray(data) && data.length === 0) {
      const { data: productosData, error: productosError } = await client
        .from('producto')
        .select('compania_id, compania:companias(id, nombre_corto)');

      if (productosError) {
        console.error('Fallback productos → compañías falló:', productosError);
        return data || [];
      }

      const uniques = [];
      const seen = new Set();
      (productosData || []).forEach((p) => {
        const comp = p?.compania;
        const cid = comp?.id;
        const nombre = comp?.nombre_corto;
        if (cid && !seen.has(cid)) {
          seen.add(cid);
          uniques.push({ id: cid, nombre_corto: nombre || '' });
        }
      });

      return uniques;
    }

    return data || [];
  } catch (error) {
    console.error('Error al obtener compañías:', error);
    throw error;
  }
};
